import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";
import { Container } from "../common-styles"

const footerStyle = (theme: Theme) => createStyles({
    Container,

    a: {
        color: theme.palette.grey["500"],
        textDecoration: "none",
        backgroundColor: "transparent"
    },

    footer: {
        position: "fixed",
        bottom: "0",
        paddingLeft: 5,
        paddingRight: 5,
        lineHeight: "24px",
        borderTop: "1px solid #e7e7e7",
        width: "100%",
        backgroundColor: theme.palette.grey["100"],
    },

    block: {
        color: "inherit",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        display: "block",
        fontWeight: 500,
        fontSize: "12px",
    },
    left: {
        float: "left",
        display: "block"
    },
    right: {
        float: "right"
    },

    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0"
    },
    inlineBlock: {
        display: "inline-block",
        paddingTop: "0px",
        paddingBottom: "0px",
        width: "auto"
    }
});
export default footerStyle;
